/**
 * Admin Dashboard Service — KPIs cross-tenant para el SUPER_ADMIN.
 */

import { get } from '@/lib/api'
import { API_ROUTES } from '@/config/constants'

export interface InstitutionsByStatus {
  active: number
  trial: number
  gracePeriod: number
  suspended: number
  cancelled: number
  withoutSubscription: number
  totalActiveInstitutions: number
}

export interface BusinessKpis {
  institutionsByStatus: InstitutionsByStatus
  revenue: {
    mrrCop: number
    paymentsThisMonthCop: number
    paymentsThisMonthCount: number
  }
  upcomingExpirations: {
    next7Days: number
    next30Days: number
  }
  trialsExpiringSoon: number
  systemHealth: {
    database: 'ok' | 'error'
    storage: 'ok' | 'degraded' | 'error'
    schedulers: { name: string; isRunning: boolean }[]
  }
  alerts: Array<{
    severity: 'info' | 'warning' | 'critical'
    title: string
    message: string
    institutionId?: string
  }>
}

export interface RecentActivityResponse {
  logs: Array<{
    id: string
    userId: string | null
    userEmail: string | null
    userRole: string | null
    action: string
    resourceType: string
    resourceId: string | null
    resourceName: string | null
    status: string
    ipAddress: string | null
    createdAt: string
  }>
  total: number
}

export interface InstitutionSummary {
  id: string
  name: string
  slug: string
  city: string | null
  isActive: boolean
  plan: {
    code: string
    name: string
    monthlyPriceCop: number
  } | null
  subscription: {
    status: string
    trialEndsAt: string | null
    expiresAt: string | null
  } | null
}

export interface InstitutionsSummaryResponse {
  institutions: InstitutionSummary[]
}

export const getBusinessKpis = (): Promise<BusinessKpis> =>
  get<BusinessKpis>(API_ROUTES.ADMIN_DASHBOARD.BUSINESS_KPIS)

export const getRecentActivity = (): Promise<RecentActivityResponse> =>
  get<RecentActivityResponse>(API_ROUTES.ADMIN_DASHBOARD.RECENT_ACTIVITY)

export const getInstitutionsSummary = (): Promise<InstitutionsSummaryResponse> =>
  get<InstitutionsSummaryResponse>(API_ROUTES.ADMIN_DASHBOARD.INSTITUTIONS_SUMMARY)
